import { all, fork } from 'redux-saga/effects';
//layout
import LayoutSaga from './layouts/saga';
//Auth
import AccountSaga from './auth/register/saga';
import AuthSaga from './auth/login/saga';
import ForgetSaga from './auth/forgetpwd/saga';
import ProfileSaga from './auth/profile/saga';

//menu
import MenuSaga from './menu/saga';

//TypeNotes
import TypesNotesSaga from './typeNotes/saga';

//CategoryPlans
import CategoryPlansSaga from './categoryPlans/saga';

//Associates
import AssociatesSaga from './associates/saga';

//Plans
import PlansSaga from './plans/saga';

//CategoryOrganization
import CategoryOrganizationSaga from './categoryOrganization/saga';

//Services
import ServicesSaga from './services/saga';

//Sellers
import SellersSaga from './sellers/saga';

//Offices
import OfficesSaga from './offices/saga';

//CostCenter
import CostCenterSaga from './costCenter/saga';

//CategoryFinance
import CategoryFinanceSaga from './categoryFinance/saga';

// Proposal
import ProposalSaga from './proposal/saga';

// Kinship
import KinshipSaga from './kinship/saga';

// Organizations
import OrganizationsSaga from './organizations/saga';

// Notes Associates
import NotesAssociatesSaga from './notesAssociates/saga';

// Units
import Units from './units/saga';

// Specialties
import Specialties from './specialties/saga';

// Provider Specialties
import ProviderSpecialty from './providerSpecialty/saga';

// Users
import Users from './users/saga';

// Credentials Network (NT)
import CredentialsNT from './credentialsNT/saga';

// Schedule
import Schedule from './schedule/saga';

// Upload Files
import Files from './uploadFiles/saga';

// Overview
import Overview from './overview/saga';

// Reports
import Reports from './reports/saga';

// Accounts
import AccountsSaga from './accounts/saga';

// HistoryStatus
import HistoryStatus from './historyStatus/saga';

// Supplies
import SuppliesList from './supplies/saga';

// Bills to pay
import BillsToPay from './billsToPay/saga';

// Validation Of Proposals
import ValidationOfProposals from './validationOfProposals/saga';

export default function* rootSaga() {
  yield all([
    //public
    fork(LayoutSaga),
    fork(AccountSaga),
    fork(AuthSaga),
    fork(ForgetSaga),
    fork(ProfileSaga),
    fork(MenuSaga),
    fork(TypesNotesSaga),
    fork(CategoryPlansSaga),
    fork(AssociatesSaga),
    fork(PlansSaga),
    fork(CategoryOrganizationSaga),
    fork(ServicesSaga),
    fork(SellersSaga),
    fork(OfficesSaga),
    fork(CostCenterSaga),
    fork(CategoryFinanceSaga),
    fork(ProposalSaga),
    fork(KinshipSaga),
    fork(OrganizationsSaga),
    fork(NotesAssociatesSaga),
    fork(Units),
    fork(Specialties),
    fork(Users),
    fork(CredentialsNT),
    fork(Files),
    fork(Overview),
    fork(Reports),
    fork(ProviderSpecialty),
    fork(Schedule),
    fork(AccountsSaga),
    fork(HistoryStatus),
    fork(SuppliesList),
    fork(BillsToPay),
    fork(ValidationOfProposals),
  ]);
}
